export default __webpack_public_path__ + "static/media/whitepaw.ce35e2bf.png";